import React, { useMemo } from "react";
import { Field, useFormState } from "react-final-form";
import clsx from "clsx";
import { lighten } from "@material-ui/core/styles/colorManipulator";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { Theme } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";
import WeduCheckbox from "../../../../../components/WeduCheckbox/WeduCheckbox";
import { HousingType as Housing } from "../../../constants";
import InputLabel from "@material-ui/core/InputLabel";

const useStyles = makeStyles((theme: Theme) => ({
  rootComponent: {
    marginBottom: 12,
  },
  root: {
    paddingBottom: 21,
    marginBottom: -18,
    "label + &": {
      marginTop: 4,
    },
  },
  error: {
    "& input": {
      borderRadius: 15,
      border: `1px solid ${theme.palette.error.main}`,
      boxShadow: `inset 0 1px 2px 0 ${lighten(theme.palette.error.main, 0.9)}`,
      "&:focus": {
        borderColor: theme.palette.error.main,
      },
    },
  },
  label: {
    marginTop: 24,
    marginBottom: 8,
    fontSize: 18,
    fontWeight: "bold",
    color: "#535358",
  },
  container: {
    width: 300,
  },
  checkboxGroup: {
    display: "flex",
    justifyContent: "flex-start",
    "& > .MuiFormControlLabel-root": {
      marginLeft: -9,
      marginRight: 40,
    },
  },
  asterisk: {
    color: "#535358",
    lineHeight: "inherit",
    fontSize: 16,
    fontWeight: "normal",
    marginLeft: 3,
  },
  hasError: {
    color: theme.palette.error.main,
  },
  helperText: {
    height: 0,
    fontSize: 14,
    fontWeight: 500,
    textAlign: "right",
    color: theme.palette.error.main,
  },
}));

const HousingType = (props) => {
  const classes = useStyles();
  const {
    fields: { name },
    meta: { submitError, invalid, submitFailed, dirtySinceLastSubmit },
    disabled,
  } = props;

  const hasError = useMemo(
    () => invalid && submitFailed && !dirtySinceLastSubmit,
    [invalid, dirtySinceLastSubmit, submitFailed],
  );

  const formState = useFormState();
  // todo correct code
  const [stepName, major, activeTabName] = name.split(".");
  const helperText =
    formState.submitErrors?.[stepName]?.[major]?.[activeTabName]?.housingTypes;

  return (
    <div>
      <div className={classes.label}>
        Housing Type
        {!disabled && (
          <Typography
            className={clsx(
              classes.asterisk,
              hasError && submitError && classes.hasError,
            )}
            component={"span"}
            variant={"subtitle2"}
          >
            *
          </Typography>
        )}
        {/*<InfoIcon text="Some information" portalMode={false}/>*/}
      </div>
      <div className={classes.container}>
        <div className={classes.checkboxGroup}>
          <Field
            value={Housing.BOARDING}
            label="Boarding"
            type="checkbox"
            name={name}
            disabled={disabled}
            component={WeduCheckbox}
          />
          <Field
            value={Housing.HOMESTAY}
            label="Homestay"
            type="checkbox"
            name={name}
            disabled={disabled}
            component={WeduCheckbox}
          />
          <Field
            value={Housing.DAY}
            label="Day"
            type="checkbox"
            name={name}
            disabled={disabled}
            component={WeduCheckbox}
          />
        </div>
        {hasError && (
          <InputLabel className={classes.helperText}>{helperText}</InputLabel>
        )}
      </div>
    </div>
  );
};

export default HousingType;
